import { render, staticRenderFns } from "./OtpVerificationStep.vue?vue&type=template&id=94e5cc5c&scoped=true"
import script from "./OtpVerificationStep.vue?vue&type=script&lang=js"
export * from "./OtpVerificationStep.vue?vue&type=script&lang=js"
import style0 from "./OtpVerificationStep.vue?vue&type=style&index=0&id=94e5cc5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e5cc5c",
  null
  
)

export default component.exports